<template>
  <div class="row griddivided_bottom no-margin">
    <div class="col-lg-12" v-if="isNegativeInvoice && editable">
      <div class="errorpadding">
        <span class="errormessagetext">
          <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
            {{ $t('PAY_NEGATIVE_INVOICE_MESSAGE') }}
        </span>
      </div>
    </div>

    <div class="col-lg-12 no-padding">
      <div class="newcardblock">
        <div class="row labelgrid" v-for="(header,index) in getSummaryHeaderLabels"
          :key="index">
          <div v-if="!header.feature || (header.feature && $hasFeature(header.feature))"
            class="col-5 no-padding">
            <div class="primarylabel" :class="{ 'is-disabled': !!header.disabled }">
              {{header.tlabel ? $t(header.tlabel) : header.head}} <span v-if="header.required" class="asterisk">*</span>
            </div>
          </div>
          <div v-if="!header.feature || (header.feature && $hasFeature(header.feature))"
            class="col-7 floatright no-padding">
            <div class="divcardblock" v-if="header.editableField">
              <span v-if="header.type === 'date'">
                <div v-if="!isFreightBill">
                  <div class="datepickerblock calenderstyle calender-dark">
                    <div class="datepicker-trigger">
                      <span id="datepicker-trigger-1"
                        class="text-white"
                        :class="{'text-red':!isValiddate}"
                        v-if="values[header.label]">
                        {{ displayDate(values[header.label]) }}
                      </span>
                      <span id="datepicker-trigger-1" class="text-white"  v-else>
                        {{ `Enter ${header.tlabel ? $t(header.tlabel) : header.head}` }}
                      </span>
                      <!-- <input type="text" id="datepicker-trigger" class="text-white"
                        :class="{'text-red':!isValiddate}"
                        :placeholder="`Enter ${header.tlabel ? $t(header.tlabel) : header.head}`"
                        :value="displayDate(values[header.label])"
                        @keydown = "preventDefault($event)"
                        @keyup = "preventDefault($event)"/> -->
                      <span v-if="!isValiddate">
                        <h4 class="text-grey-medium my-0">
                          {{ $t('INVALID_INVOICE_DATE') }}
                        </h4>
                      </span>
                      <AirbnbStyleDatepicker :trigger-element-id="'datepicker-trigger-1'"
                        :mode="'single'" :months-to-show="1" :date-one="values[header.label]"
                        :minDate="pastDay"
                        :endDate="futureDay"
                        @date-one-selected="val =>
                          $emit('updateValue', header.label, val, header.type)"/>

                        <svgicon name="fill_arrow" class="icon" width="10" height="10"
                          :original="true" />
                    </div>
                  </div>
                </div>
                <div v-else class="sectext_bold">
                  {{displayDate(new Date())}}
                </div>
              </span>
              <div v-else-if="header.type === 'dropdown'" class="bgcolor secdropdown">
              <div v-if="header.disabled && !isAutoBillToPartyEnabled && !isBillToPartyFromMaterialInvoice" class="is-disabled-dropdown">
                  <Tooltip class="item" effect="dark" placement="bottom" popper-class="max-width">
                    <div slot="content" class="tooltipcontent">
                      {{ $t('PAY_INVALID_INDENT_SELECTION') }}
                    </div>
                    <span>
                      <Select popper-class="bgdropdown"
                        :value="getLabel(values[header.label], header.label)"
                        :placeholder="`Select ${header.tlabel ? $t(header.tlabel) : header.head}`"
                        :disabled="header.disabled">
                      </Select>
                    </span>
                  </Tooltip>
                </div>
                <span v-else>
                  <Select popper-class="bgdropdown"
                    :value="values[header.label]"
                    :placeholder="`Select ${header.tlabel ? $t(header.tlabel) : header.head}`"
                    :disabled="header.disabled"
                    @change="updateValue(header, $event)">
                    <Option
                     v-for="item in getDropdownData(header.label)"
                     :key="item.value"
                     :label="`${item.label}`"
                     :value="item.label">
                    </Option>
                  </Select>
                </span>
              </div>
              <span v-else :class="{ 'errorfield': clickedSubmit && header.required && !values[header.label] }">
                <Tooltip class="item" effect="dark" placement="top" :content="`
                  Tax invoice number can't exceed 16 characters as per Rule 46 (b) of the CGST Rules 2017
                `" v-if="header.label === 'invoiceNumber'">
                  <input type="text" :placeholder="`Enter ${header.tlabel ? $t(header.tlabel) : header.head}`"
                    :value="values[header.label]" :readonly="!header.editableField"
                    :maxlength="`${header.maxLength || 50}`"
                    @input="validateInvoiceNumber($event)  && $emit('updateValue', header.label, $event.target.value)" @keydown="preventDefault($event)"
                    @keyup="preventDefault($event)" />
                </Tooltip>
                <input v-else type="text" :placeholder="`Enter ${header.tlabel ? $t(header.tlabel) : header.head}`"
                    :value="values[header.label]" :readonly="!header.editableField"
                    :maxlength="`${header.maxLength || 50}`"
                    @input="$emit('updateValue', header.label, $event.target.value)" @keydown="preventDefault($event)"
                    @keyup="preventDefault($event)" />
              </span>
              <span class="errormessagetext" v-if="clickedSubmit && header.required && (!values[header.label] || values[header.label] === '--')">
                <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
                {{ $t('PAY_CANNOT_BE_BLANK') }}
              </span>
            </div>
            <div v-else class="sectext_bold">
              <span v-if="header.type === 'date'">{{displayDate(values[header.label])}}</span>
              <span v-else-if="header.label === 'billToParty'">{{getLabel(values[header.label], header.label)}}</span>
              <Tooltip class="item" effect="dark" placement="bottom"
                v-else-if="header.label === 'irnNumber' && values[header.label] && values[header.label].length > 25">
                <div slot="content" class="tooltipcontent">
                  {{values[header.label]}}
                </div>
                <span>{{values[header.label].substring(0,20)}}...</span>
              </Tooltip>
              <span v-else>{{ values[header.label] }}</span>
            </div>
          </div>
        </div>
        <div class="row labelgrid" v-if="!savedBillParty">
          <div class="errormessagetext">
            <svgicon name="warning" class="icon" width="10" height="10" :original="true" />
            {{ $t('PAY_CONFIRM_CHANGE_PROMPT') }}
          </div>
          <div class="col-8 no-padding text-white"> Are you sure want to switch to {{selectedBillParty}} depot</div>
          <div class="col-4 floatright no-padding">
            <div class="sectext_bold text-xs">
              <Button type="text" size="mini" class="text-white p-0" @click="reset">{{ $t('NO') }}</Button>
              <Button type="text" size="mini" class="m-0" @click="saveBillParty">{{ $t('YES') }}</Button>
            </div>
          </div>
        </div>
        <div class="row labelgrid" v-if="isDestinationSelected && values.isSezEnabled">
          <Checkbox class="dark" :value="values.sez" @change="$emit('updateValue', 'sez', $event)">
            <span class="text-white text-sm">{{ $t('PAY_SEZ_MESSAGE') }}</span>
          </Checkbox>
        </div>

        <div class="row mx-m10" v-if="addressClicked && billToParty && !isFreightBill" v-on:click="onClick">
            <div class="bgfooter full-width px-15">
              <div class="row labelgrid py-5  mb-0">
                  <div class="col-12 no-padding">
                      <div class="primarylabel">{{ values.entityName }}</div>
                  </div>
              </div>
              <div class="row labelgrid py-5 mb-0 text-normal">
                  <div class="col-12 no-padding">
                      <div class="primarylabel" style="line-height:16px;">{{ values.address }}, {{ values.city }}, {{ values.state }} - {{ values.pincode }}</div>
                      <div class="primarylabel mt-10" style="line-height:16px;">{{ $t('GSTIN') }}: {{ values.gst }}</div>
                  </div>
              </div>
            </div>
         </div>

        <div class="row mx-m10" v-else-if="!isFreightBill">
          <div class="bgfooter full-width text-normal px-15" v-on:click.self="onClick">
            <div class="row labelgrid py-5 mb-0">
              <div class="col-5 no-padding">
                <div class="primarylabel">{{ $t('NAME_OF_ENTITY') }}</div>
              </div>
              <div class="col-7 floatright no-padding">
                <div class="divcardblock">
                  <span>
                    <input type="text" :disabled="disableField" v-model="values.entityName" @input="$emit('updateValue', 'entityName', $event.target.value)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="row labelgrid py-5 mb-0">
              <div class="col-5 no-padding">
                <div class="primarylabel">{{ $t('ADDRESS') }}</div>
              </div>
              <div class="col-7 floatright no-padding">
                <div class="divcardblock">
                  <span>
                    <input type="text" :disabled="disableField" v-model="values.address" @input="$emit('updateValue', 'billToPartyAddress', $event.target.value)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="row labelgrid py-5 mb-0">
              <div class="col-5 no-padding">
                <div class="primarylabel">{{ $t('CITY') }}</div>
              </div>
              <div class="col-7 floatright no-padding">
                <div class="divcardblock">
                  <span>
                    <input type="text" :disabled="disableField" v-model="values.city" @input="$emit('updateValue', 'billToPartyCity', $event.target.value)"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="row labelgrid py-5 mb-0">
              <div class="col-5 no-padding">
                <div class="primarylabel">{{ $t('STATE') }}</div>
              </div>
              <div class="col-7 floatright no-padding">
                <div class="divcardblock">
                  <span>
                    <input type="text" :disabled="true" :value="values.state" v-if="disableField"/>
                    <Select v-model="values.state" placeholder="Select" popper-class="bgdropdown"
                      @change="$emit('updateValue', 'billToPartyState', $event)" v-else>
                      <Option
                        v-for="state in states"
                        :key="state.name"
                        :label="state.name"
                        :value="state.name">
                      </Option>
                    </Select>
                  </span>
                </div>
              </div>
            </div>
            <div class="row labelgrid py-5 mb-0">
              <div class="col-5 no-padding">
                <div class="primarylabel">{{ $t('GSTIN') }}</div>
              </div>
              <div class="col-7 floatright no-padding">
                <div class="divcardblock">
                  <span>
                    <input type="text" :disabled="disableField" v-model="values.gst" @input="$emit('updateValue', 'billToPartyGst', $event.target.value)"/>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { formatDisplaySingleDate } from '@/lib/Date';
import states from '@/constants/india-states';
import { SummaryHeaderLabels, SummaryHeaderLabelsFreightBill, daysInMillis, invoiceStatus } from '@/constants/payments';
import { cloneDeep } from 'lodash';
import { InvoiceStatusUtils } from 'status-utils';


export default {
  props: {
    editable: {
      type: Boolean,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
    clickedSubmit: {
      type: Boolean,
      required: false,
    },
    isNegativeInvoice: {
      type: Boolean,
      required: true,
    },
    status: {
      type: Number,
      required: true,
    },
    hsnSacList: {
      type: Array,
    },
    isFreightBill: false,
    editableBillParty: {
      type: Boolean,
      default: false,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
    eInvoiceEnabled: {
      type: Boolean,
      default: false,
    },
    billToPartyValues: {
      type: Array,
    },
    billToParty: {
      type: String,
    },
    isAutoBillToPartyEnabled: {
      type: Boolean,
      default: false,
    },
    pastDay: {
      type: String,
      default() {
        return new Date(new Date().getTime() - (31 * daysInMillis));
      },
    },
    futureDay: {
      type: String,
      default: new Date(),
    },
    isValiddate: {
      type: Boolean,
      default: false,
    },
    centralHOEnabled: {
      type: Boolean,
      default: false,
    },
    invoiceId: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      SummaryHeaderLabels,
      SummaryHeaderLabelsFreightBill,
      savedBillParty: true,
      selectedBillParty: '',
      resetBillToParty: '',
      addressClicked: true,
      states,
      billToPartyFilterEnabled: this.$hasFeature('bill_to_party_filter_in_invoice_flow'),
      isEditBillToPartyEnabled: this.$hasPermission('edit_bill_to_party'),
      isBillToPartyFromMaterialInvoice: this.$hasFeature('bill_to_party_in_material_invoice'),
    };
  },
  computed: {
    ...mapGetters({
      invoiceApprovalSettings: 'paymentsV2/invoiceApprovalSettings',
      invoiceLevelApprovalSettings: 'paymentsV2/invoiceLevelApprovalSettings',
      currentClientConfig: 'app/currentClientConfig',
      selectedLegalEntity: 'paymentsV2/selectedLegalEntity',
    }),
    isLegalEntityBasedOnBillToParty() {
      return this.$hasFeature('legal_entity_based_on_bill_to_party') && this.selectedLegalEntity;
    },
    isRestrictTransporterGenerateInvoice() {
      return (this.currentClientConfig && this.currentClientConfig.restrict_transporter_generate_invoice && this.currentClientConfig.restrict_transporter_generate_invoice.is_enabled);
    },
    disableField() {
      if (this.isLegalEntityBasedOnBillToParty) {
        return true;
      }
      return !(this.editable && this.$hasPermission('update_bill_to_party') && !this.centralHOEnabled);
    },
    canEditInvoiceNumberDate() {
      if (!this.invoiceLevelApprovalSettings || !this.invoiceLevelApprovalSettings.invoice_approval_flow || !this.invoiceLevelApprovalSettings.invoice_approval_flow.length) return false;
      
      let statusName = '';
      if (this.values && this.values.customStatus) {
        statusName = this.values.customStatus;
      } else if (this.values && this.values.invoiceStatus) {
        const statusObj = InvoiceStatusUtils.getStatusObjById(this.values.invoiceStatus);
        if (statusObj && statusObj.label) {
          statusName = statusObj.label;
        }
      }
      
      const statusSetting = this.invoiceLevelApprovalSettings.invoice_approval_flow
        .find(flow => flow.status_name === statusName);
      
      return statusSetting && statusSetting.edit_invoice_number_date === true;
    },
    getSummaryHeaderLabels() {
      let headers = this.SummaryHeaderLabels;
      if (this.isFreightBill) {
        headers = this.SummaryHeaderLabelsFreightBill;
      }
      const clonedHeaders = cloneDeep(headers);
      clonedHeaders.map((_header) => {
        // based on editable flag, change the editable state of headers
        const header = _header;
        if (this.isInvoice) {
          header.editableField = header.invoiceEditable;
        }
        if (header.label === 'billToParty') {
          /** when editableBillParty is false,
           Ready for billing - disabled and Invoice - non-editable
           when user don't have update_bill_to_party permissions - non -editable */
          if (this.isBillToPartyFromMaterialInvoice && !this.isInvoice) {
            header.editableField = false;
          } else if (this.billToPartyFilterEnabled && !this.isEditBillToPartyEnabled) {
            header.editableField = false;
          } else if ((!this.editableBillParty && !this.isInvoice) || !this.isEditBillToPartyEnabled) {
            header.disabled = true;
          } else {
            header.editableField = this.editableBillParty;
          }
        } else if (header.label === 'irnNumber' || header.label === 'invoiceDate') {
          if (this.editable || (this.status === invoiceStatus.CHECKED && this.eInvoiceEnabled)) {
            header.editableField = true;
          } else {
            header.editableField = false;
          }
          header.required = (header.label === 'irnNumber' && this.status === invoiceStatus.CHECKED
            && this.eInvoiceEnabled);
        } else if (!this.editable) {
          header.editableField = false;
        }
        if (this.$hasFeature('auto_generate_proforma_invoice_number') && header.label === 'invoiceNumber') {
          if (this.editable) {
            header.editableField = false;
          } else if ([invoiceStatus.CHECKED, invoiceStatus.CUSTOM].includes(this.status)) {
            header.editableField = true;
          }
        }
        if ((header.label === 'invoiceDate' || header.label === 'invoiceNumber')) {
          if (this.$hasFeature('custom_invoice_approval') && this.$hasFeature('auto_generate_proforma_invoice_number')) {
            header.editableField = false;
          }
          if (this.$hasFeature('custom_invoice_approval') && this.$hasFeature('auto_generate_proforma_invoice_number') && this.canEditInvoiceNumberDate) {
            header.editableField = true;
          }
        }
        // Handle mandatory fields from configuration
        if (this.isRestrictTransporterGenerateInvoice) {
          const mandatoryFields = this.currentClientConfig.restrict_transporter_generate_invoice.mandatory_fields || [];
          const isMandatory = mandatoryFields.some(field => {
            // Convert snake_case to camelCase for frontend label matching
            const camelCaseField = field.field.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
            return camelCaseField === header.label;
          });
          if (isMandatory) {
            header.required = true;
          }
        }
      });
      return clonedHeaders;
    },
    isDestinationSelected() {
      return (this.values.billToParty === 'destination');
    },
  },
  methods: {
    onClick() {
      this.addressClicked = !this.addressClicked;
    },
    displayDate(date) {
      let formattedDates = '';
      if (date) {
        formattedDates = formatDisplaySingleDate(date);
      }
      return formattedDates;
    },
    preventDefault(event) {
      event.stopPropagation();
    },
    getDropdownData(label) {
      let data = [];
      switch (label) {
        case 'hsnSac':
          data = this.hsnSacList.map(item => ({ label: item.code, value: item.code }));
          break;
        case 'billToParty':
          data = this.billToPartyValues;
          break;
        default:
          break;
      }
      return data;
    },
    updateValue(header, val) {
      if (header.label === 'billToParty') {
        // update only after confirmation from User
        this.savedBillParty = false;
        this.selectedBillParty = val;
        this.values.billToParty = val;
        this.$emit('disableSubmit');
      } else {
        this.$emit('updateValue', header.label, val, header.type);
      }
    },
    getLabel(value, label) {
      if (label === 'billToParty') {
        if (value) {
          if (this.isInvoice) {
            return this.billToParty;
          }
          const found = this.billToPartyValues &&
            this.billToPartyValues.find(item => item.value === value);
          return found ? found.label : value;
        }
      }
      return value;
    },
    reset() {
      let billPartyValue;
      if (this.resetBillToParty) {
        billPartyValue = this.resetBillToParty;
        this.selectedBillParty = this.resetBillToParty;
      } else {
        billPartyValue = this.billToPartyValues[0].label;
        this.selectedBillParty = this.billToPartyValues[0].label;
      }
      this.values.billToParty = billPartyValue;
      this.savedBillParty = true;
      const billParty = this.billToPartyValues.find(
        billToParty => billToParty.label === billPartyValue);
      this.$emit('updateValue', 'billToParty', {
        billToParty: billPartyValue,
        billToParyId: billParty.billToPartyId,
        address: billParty.address,
        city: billParty.city,
        state: billParty.state,
        gst: billParty.gst,
        pincode: billParty.pincode,
        companyName: billParty.companyName || billParty.label || billPartyValue,
      });
    },
    validateInvoiceNumber(evt) {
      const regexStr = /[^a-zA-Z0-9/-]/g;
      evt.target.value = evt.target.value.replace(regexStr, '');
      this.values.invoiceNumber = evt.target.value;
      return evt.target.value;
    },
    saveBillParty() {
      const billParty = this.billToPartyValues.find(
        billToParty => billToParty.label === this.selectedBillParty);
      this.$emit('updateValue', 'billToParty', {
        billToParty: this.selectedBillParty,
        billToParyId: billParty.billToPartyId,
        address: billParty.address,
        city: billParty.city,
        state: billParty.state,
        gst: billParty.gst,
        pincode: billParty.pincode,
        companyName: billParty.companyName || billParty.label || this.selectedBillParty,
      });
      this.savedBillParty = true;
      this.resetBillToParty = this.selectedBillParty;
    },
  },
};
</script>
